import { Injectable } from "@angular/core";
import { BaseStyle } from "primeng/base";

@Injectable({ providedIn: "root" })
export class SidenavHeaderStyle extends BaseStyle {
  override name = "sidenavheader";

  override classes = {
    root: "ui-sidenavheader",
  };
}
